import type { Substation } from "@/lib/api";
import type { SearchableOption } from "@/components/searchable-selector";

export function substationPickerOption(
  station: Substation,
  stations: readonly Substation[] = [],
): SearchableOption {
  const context = [
    station.distribution_company_name,
    `Type: ${station.station_type ?? "Unknown"}`,
    station.voltage_kv == null ? null : `${station.voltage_kv} kV`,
    station.external_key,
    `ID ${station.substation_id}`,
  ].filter(Boolean).join(" · ");
  return {
    value: String(station.substation_id),
    label: stations.filter((other) =>
      other.name.trim().toLocaleLowerCase() === station.name.trim().toLocaleLowerCase()).length > 1
      ? `${station.name} · ID ${station.substation_id}` : station.name,
    context,
    searchText: [station.base_name, station.state, station.city, station.address_line,
      ...(station.served_states ?? []), station.tcn_region, station.tcn_subregion].filter(Boolean).join(" "),
  };
}
